export default __webpack_public_path__ + "static/media/declineOff.41a255d3.svg";